import React from "react";
import PrivateRoute from "common/routes/PrivateRoute/PrivateRoute";

export default function NotasProtectedRoute(props){
    return <PrivateRoute allowedroles={["notas-debito",'administrator','recepcion']}>
        {props.children}
    </PrivateRoute>;
}